import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { SPACE } from "../utils/frfr-string-consts";
import { derAutoCreateVirbom_terkk_elasticnaveza_children, derAutoCreateVirbom_terkk_elasticnaveza_prepare_vir_input } from "./ter-derivat-lib-terkk-elasticnaveza";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$elasticnaveza = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$elasticnaveza.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$elasticnaveza',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    // prirubnica: '',
    prirubnica: 'METZ 30',
    platno: 'STANDARDNA',
    sirinaa: null,
    visinab: null,
    montiranjenademper: false,
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$elasticnaveza.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$elasticnaveza.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$elasticnaveza.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$elasticnaveza');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = formState;
  const evzNaziv = 'ELASTICNA VEZA' + SPACE +
    p.prirubnica + SPACE +
    p.sirinaa + 'x' + p.visinab + SPACE +
    p.platno;
  state.naziv = evzNaziv;
  const state2 = {
    virtelschemakey: 'terkk$elasticnaveza',
    ...state,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$elasticnaveza") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$elasticnaveza.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$elasticnaveza');
  const virtel = draftel_codecs_pack_terkk$elasticnaveza.drafel_to_virtel(draftel);

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // KORAK poluproizvod level 3 virtel
  // graphlevel: 3,
  // const graphlevel = 3;
  const local_graphlevel = 1;
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
  _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);

  // KORAK pripreme derivata za elasticnaveza
  let pods_input_za_derivate = derAutoCreateVirbom_terkk_elasticnaveza_prepare_vir_input(draftel); // ??? 
  let _derivati = derAutoCreateVirbom_terkk_elasticnaveza_children(pods_input_za_derivate);
  console.log('_derivati elasticnaveza');
  console.log(_derivati);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$elasticnaveza.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$elasticnaveza.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$elasticnaveza.keys_for_direct_cloning)
  };
  //
  return state;
};

